"use strict";

import $ from "jquery";
import { initModalVideoPlayer } from "../../_scripts/helpers";

export default class Modal {
  constructor() {
    this.initModal();
    this.$modal = $("body > [data-modal]");
  }

  initModal() {
    if (!this.$modal) {
      $("body").append(`<div data-modal>
        <div class='modal-body'></div>
      </div>`);
      this.$modal = $("body > [data-modal]");
    }
    $(".modal-body", this.$modal).on("click", (e) =>{
      e.stopPropagation()
    });
    this.$modal.on("click", () => {
      this.closeModal();
    });
    $(document).on("keyup",(e) =>{
      this.closeModal();
    });

    $("[data-modal-toggle]").map((_, ele) => {
      $(ele).on("click", (e) => {
        e.preventDefault();

        if(!$(ele).parents().hasClass('slick-slider') || $(ele).data("modalOpenDefault")) {
          let modalContent;
          if ((typeof $(ele).attr('data-shared-modal') !== 'undefined')) {
            modalContent = $(ele).parent().siblings("[data-modal-content]").clone();
          } else {
            modalContent = $("[data-modal-content]", $(ele)).clone();
          }
          // not inside a carousel, just open
          $(".modal-body", this.$modal).html(modalContent);
          initModalVideoPlayer(this.$modal);
          this.openModal();
        }
        else {
          // if in carousel
          if($(ele).parents().hasClass('slick-current')) {
            let modalContent = $("[data-modal-content]", $(ele)).clone();
            $(".modal-body", this.$modal).html(modalContent);
            initModalVideoPlayer(this.$modal);
            this.openModal();
          }
        }
      });
    });
  }

  openModal() {
    $("body").addClass("no-scroll");
    this.$modal.fadeIn(400, () => {
      $("[data-modal-close]").on("click", () => this.closeModal());
    });
  }

  closeModal() {
    $("body").removeClass("no-scroll");
    this.$modal.fadeOut(400, () => {
      $("[data-modal-content]", this.$modal).remove();
    });
  }
}
